import serialize from 'serialize-javascript';

export const jsonLdSafeStringify = (data: unknown): string => {
  // serialize-javascript safely serializes JSON for embedding in <script type="application/ld+json">
  return serialize(data, { isJSON: true });
};

export default jsonLdSafeStringify;
